import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefundInvoice.Delete.IRequest;
type Response = Api.Sales.ContractRefundInvoice.Delete.IResponse;
type Headers = Api.Sales.ContractRefundInvoice.Delete.IHeaders;
const url = '/api/Sales/ContractRefundInvoice/:id';
export default async function contractRefundInvoiceDeleteApi(params: { id: number }): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
